<p-toast></p-toast>
<div class="container">
  <div class="toolbar-container">
    <p-iconField iconPosition="left">
      <p-inputIcon styleClass="pi pi-id-card" />
      <input type="text" pInputText placeholder="Render Name" [(ngModel)]="renderName" (change)="updateRenderName()"/>
    </p-iconField>
    <div class="buttons">
      <p-button id="export-button" icon="pi pi-save" size="small" label="Export" (onClick)="openExportDialog()"/>
        <div class="button-group">
          <!-- <p-button icon="pi pi-cog" [text]="true" [outlined]="true" severity="secondary" size="small" pTooltip="Settings" tooltipPosition="bottom"/> -->
          <!-- <p-button icon="pi pi-question-circle" [text]="true" [outlined]="true" severity="info" size="small" pTooltip="Help" tooltipPosition="bottom"/> -->
          <!-- <p-button icon="pi pi-directions" [text]="true" [outlined]="true" severity="success" size="small" pTooltip="Redo" tooltipPosition="bottom"/> -->
          <!-- <p-button icon="pi pi-directions-alt" [text]="true" [outlined]="true" severity="success" size="small" pTooltip="Undo" tooltipPosition="bottom"/> -->
          <p-button icon="pi pi-undo" [text]="true" [outlined]="true" severity="danger" size="small" pTooltip="Reset to initial state" tooltipPosition="bottom" (onClick)="resetEditorState.emit()"/>
        </div>
    </div>
  </div>
  <div class="canvas-container" id="render-view">
    <div class="sub-container">
      <canvas id="renderview" appCanvas #canvas>
      </canvas>
      @if (showMessage) {
        <p-messages
          [(value)]="initialMessages"
          [enableService]="false"
          [closable]="true"
          >
        </p-messages>
      }
    </div>
  </div>
</div>
